import React from 'react'
import {render} from 'react-dom'
import {Provider} from 'react-redux'
import {ConnectedRouter} from 'connected-react-router'
import store, {history} from './store'
import App from './containers/app'
// import * as serviceWorker from './serviceWorker';

import './index.css'
import './responsive.css'
import 'react-quill/dist/quill.snow.css' // ES6
import 'react-quill/dist/quill.bubble.css' // ES6

const target = document.querySelector('#root')

var moment = require('moment-timezone');
moment.tz.setDefault("Asia/Kolkata");

// serviceWorker.register();

render(
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <App/>
        </ConnectedRouter>
    </Provider>,
    target
)
